import { Popover, Tag } from "antd";
import dayjs from "dayjs";
import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { ReactComponent as ICON_DISPLAY_SETTING } from "@assets/svgs/ICON_DISPLAY_SETTING.svg";
import { ReactComponent as ICON_FORCE_SYNC } from "@assets/svgs/ICON_FORCE_SYNC.svg";
import { ReactComponent as ICON_LINK } from "@assets/svgs/ICON_LINK.svg";
import { ReactComponent as ICON_MEDIA_INFO } from "@assets/svgs/ICON_MEDIA_INFO.svg";
import { ReactComponent as ICON_PREVIEW } from "@assets/svgs/ICON_PREVIEW.svg";
import { ReactComponent as ICON_TABLE_DELETE } from "@assets/svgs/ICON_TABLE_DELETE.svg";
import { ReactComponent as ICON_TABLE_EDIT } from "@assets/svgs/ICON_TABLE_EDIT.svg";
import { Text } from "@components/Text";
import { ContentInfo } from "@pages/ImportantListPage/ContentInfo";
import { COLOR_DARK_GREY } from "@static/COLORS";

const SectionTableAction = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const BASE_IMPORTANT_LIST_TABLE_COLUMNS = [
  {
    title: "#",
    dataIndex: "index",
    key: "index",
    fixed: "left",
    width: 80,
    sorter: (a, b) => a.index - b.index,
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    fixed: "left",
    width: 280,
  },
  {
    title: "Total Duration (Sec)",
    dataIndex: "totalDuration",
    key: "totalDuration",
    align: "center",
    width: 120,
    render: (text, item, index) => {
      console.log("item :>> ", item);
      const maxDuration = _.chain(item)
        .get(["importantCampaignBlocks"])
        .map((importantCampaignBlockItem) => {
          const filterBlockMedias = _.chain(importantCampaignBlockItem)
            .get(["importantCampaignBlockMedias"])
            .filter((filterBlockMediaItem) => {
              const endDate = _.get(filterBlockMediaItem, "end_date");
              return !dayjs(endDate).isBefore(dayjs());
            })
            .value();
          return {
            ...importantCampaignBlockItem,
            blockMedias: filterBlockMedias,
          };
        })
        .map((item) => {
          const blockMedias = _.get(item, ["blockMedias"]);
          const totalDuration = _.sumBy(blockMedias, (media) => {
            const duration = _.get(media, "duration", 0);
            const repeat = _.get(media, "repeat", 1);
            return duration * repeat;
          });

          return totalDuration;
        })
        .max()
        .value();

      return <Text align="center">{maxDuration}</Text>;
    },
  },
  {
    title: "Details",
    key: "details",
    align: "center",
    width: 120,

    render: (text, item, index) => {
      return (
        <Popover
          content={<ContentInfo key={index} data={item} />}
          title="Details"
          trigger="click"
        >
          <ICON_MEDIA_INFO
            style={{ cursor: "pointer" }}
            fill={COLOR_DARK_GREY}
            width={"20px"}
            height={"20px"}
          />
        </Popover>
      );
    },
  },
];

export const getImportantListTableColumns = ({
  onHandleEdit,
  onHandleDelete,
  onHandleRedirect,
  onHandlePreview,
  showConfirmation,
  onHandleForceSycGroup,
  onHandleLinkDevices,
}) => {
  const importantListColumns = [...BASE_IMPORTANT_LIST_TABLE_COLUMNS];

  return [
    ...importantListColumns,
    {
      title: "Actions",
      key: "actions",
      width: 120,
      render: (text, item, index) => {
        return (
          // isWithKios
          <SectionTableAction key={index}>
            <Popover placement="top" trigger="hover" content={<div>Link</div>}>
              <ICON_LINK
                width={12}
                height={12}
                onClick={() => onHandleLinkDevices({ item })}
              />
            </Popover>
            <Popover
              placement="top"
              trigger="hover"
              content={<div>Force Sync</div>}
            >
              <ICON_FORCE_SYNC
                className={"icon-clickable"}
                width={24}
                height={24}
                onClick={() =>
                  showConfirmation({
                    title: "Force Sync",
                    onConfirm: () => onHandleForceSycGroup({ item }),
                  })
                }
              />
            </Popover>
            <Popover
              placement="top"
              trigger="hover"
              content={<div>Preview</div>}
            >
              <ICON_PREVIEW
                width={18}
                height={18}
                // onClick={() => onHandlePreview({ item })}
                onClick={() =>
                  showConfirmation({
                    title: "Go to preview",
                    onConfirm: () => onHandlePreview({ item }),
                  })
                }
              />
            </Popover>
            <Popover
              placement="top"
              trigger="hover"
              content={<div>Go to important block</div>}
            >
              <ICON_DISPLAY_SETTING
                width={20}
                height={20}
                onClick={() =>
                  showConfirmation({
                    title: "Go to important block",
                    onConfirm: () => onHandleRedirect({ item }),
                  })
                }
              />
            </Popover>
            <Popover placement="top" trigger="hover" content={<div>Edit</div>}>
              <ICON_TABLE_EDIT
                width={24}
                height={24}
                onClick={() => onHandleEdit({ item })}
              />
            </Popover>
            <Popover
              placement="top"
              trigger="hover"
              content={<div>Delete</div>}
            >
              <ICON_TABLE_DELETE
                width={24}
                height={24}
                onClick={() =>
                  showConfirmation({
                    title: "Delete",
                    onConfirm: () => onHandleDelete({ item }),
                  })
                }
              />
            </Popover>
          </SectionTableAction>
        );
      },
    },
  ];
};
